import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { GlobalReducer } from './interfaces/GlobalReducer';
import { Alert } from './interfaces/Alert';
import type { AppDispatch } from '../store';

let alertTimeout: string | number | NodeJS.Timeout | undefined;

const initialState: GlobalReducer = {
  loader: false,
  alert: {
    message: '',
    visibility: false,
    type: 'CORRECT',
    timeout: 5000,
    onCloseClick: () => {},
  },
};

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setLoader: (state, action: PayloadAction<boolean>) => {
      state.loader = action.payload;
    },
    showAlert: (state, action: PayloadAction<Alert>) => {
      action.payload.visibility = true;
      state.alert = action.payload;
    },
    hideAlert: state => {
      state.alert = initialState.alert;
    },
  },
});

export const showAlert = async (dispatch: AppDispatch, payload: Alert) => {
  clearTimeout(alertTimeout);
  dispatch(globalSlice.actions.showAlert(payload));

  const timeout = payload.timeout || 5000;

  let onCloseClickFunc = payload.onCloseClick;
  if (!onCloseClickFunc || typeof onCloseClickFunc !== 'function') {
    onCloseClickFunc = () => clearTimeout(alertTimeout);
  }

  if (timeout)
    alertTimeout = setTimeout(() => {
      dispatch(globalSlice.actions.hideAlert());
    }, timeout);
};

export const hideAlert = async (dispatch: AppDispatch) => {
  clearTimeout(alertTimeout);
  dispatch(globalSlice.actions.hideAlert());
};

export const setLoader = async (dispatch: AppDispatch, payload: boolean) => {
  dispatch(globalSlice.actions.setLoader(payload));
};

const globalReducer = globalSlice.reducer;
export default globalReducer;
